/**
 * Constantes para os nomes das actions do Corel
 * Centraliza todos os nomes de actions para evitar inconsistências
 */

export const COREL_ACTIONS = {
  // Actions de exportação
  EXPORT_BATCH: 'corel-export-batch',
  EXPORT_SIMPLE: 'corel-export-simple',
  EXPORT_PNG: 'exportar-objetos-png-lite',
  
  // Actions de arquivo
  SAVE_FILE: 'salvararquivo',
  OPEN_FILE: 'abrir-arquivo',
  CLOSE_DOCUMENT: 'fechar-documento',
  
  // Actions de objetos
  NAME_OBJECTS: 'nomear-objetos',
  FOCUS_OBJECT_BY_STATIC_ID: 'focar-objeto-por-staticid',
  LIST_LAYERS: 'listar-camadas',
  
  // Actions de monitoramento
  MONITOR_OBJECTS: 'monitorar-objetos',
  
  // Actions de organização
  ORGANIZE_LAYER: 'organizar-camada',
  
  // Actions de sistema
  APP_STATUS: 'app-status',
  HEALTH_PONG: 'health:pong',
} as const;

/**
 * Tipo para os nomes das actions
 */
export type CorelActionName = typeof COREL_ACTIONS[keyof typeof COREL_ACTIONS];

/**
 * Valida se uma string é um nome de action válido
 */
export function isValidCorelAction(action: string): action is CorelActionName {
  return Object.values(COREL_ACTIONS).includes(action as CorelActionName);
}
